import COLORS from './colors';

const customerByMessagesChartConfig = {
  name: 'customers_by_messages',
  title: 'Message Frequency',
  metric: 'customers_by_messages',
  linesColor: COLORS.orange,
  downloadUsingLineLabels: false,
  lines: {
    customers_by_messages: {
      label: 'Messages',
      position: 1,
      color: COLORS.orange,
    },
  },
};

export default customerByMessagesChartConfig;
